import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_4127_26901)">
        <path
          d="M13.44 22.5599C19.2721 22.5599 24 17.8321 24 11.9999C24 6.16781 19.2721 1.43994 13.44 1.43994C7.60788 1.43994 2.88 6.16781 2.88 11.9999C2.88 17.8321 7.60788 22.5599 13.44 22.5599Z"
          fill="#9B9C9C"
        />
        <path
          d="M10.56 22.5599C16.3921 22.5599 21.12 17.8321 21.12 11.9999C21.12 6.16781 16.3921 1.43994 10.56 1.43994C4.72787 1.43994 0 6.16781 0 11.9999C0 17.8321 4.72787 22.5599 10.56 22.5599Z"
          fill="#575757"
        />
        <path
          d="M11.9999 24C17.8321 24 22.5599 19.2721 22.5599 13.44C22.5599 7.60788 17.8321 2.88 11.9999 2.88C6.16781 2.88 1.43994 7.60788 1.43994 13.44C1.43994 19.2721 6.16781 24 11.9999 24Z"
          fill="#454545"
        />
        <path
          d="M11.9999 21.12C17.8321 21.12 22.5599 16.3921 22.5599 10.56C22.5599 4.72787 17.8321 0 11.9999 0C6.16781 0 1.43994 4.72787 1.43994 10.56C1.43994 16.3921 6.16781 21.12 11.9999 21.12Z"
          fill="#737373"
        />
        <path
          d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
          fill="#1E1E1E"
        />
        <path
          d="M12.8569 15.2333V18H9.93299V15.2333H12.8569ZM7 7.9086C7.38985 6.97453 7.98376 6.25625 8.78173 5.75375C9.58579 5.25125 10.5421 5 11.6508 5C12.5218 5 13.2832 5.13597 13.935 5.40791C14.5868 5.67985 15.0924 6.04343 15.4518 6.49864C15.8173 6.95384 16 7.4593 16 8.01501C16 8.59436 15.8782 9.08799 15.6345 9.49591C15.397 9.90382 15.1046 10.2703 14.7574 10.5955C14.4102 10.9147 14.0599 11.234 13.7066 11.5532C13.3594 11.8665 13.067 12.2183 12.8294 12.6085C12.5919 12.9927 12.4731 13.4538 12.4731 13.9918H10.3259C10.3259 13.3415 10.4264 12.7799 10.6274 12.307C10.8345 11.8281 11.0873 11.4113 11.3858 11.0566C11.6904 10.696 11.9919 10.3649 12.2904 10.0634C12.5888 9.76194 12.8386 9.46044 13.0396 9.15894C13.2467 8.85152 13.3503 8.51455 13.3503 8.14802C13.3503 7.72829 13.1858 7.39427 12.8569 7.14597C12.534 6.89768 12.1259 6.77353 11.6325 6.77353C11.3036 6.77353 10.9838 6.84447 10.6731 6.98636C10.3624 7.12233 10.0822 7.31446 9.83249 7.56276C9.58883 7.81105 9.4 8.10368 9.26599 8.44065L7 7.9086Z"
          fill="#737373"
        />
      </g>
      <defs>
        <clipPath id="clip0_4127_26901">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  );
};

export default Icon;
